webpackJsonp([201554622336692],{

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(9);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Divider = __webpack_require__(6);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Fill = __webpack_require__(5);
	
	var _Fill2 = _interopRequireDefault(_Fill);
	
	var _Wave = __webpack_require__(50);
	
	var _Wave2 = _interopRequireDefault(_Wave);
	
	var _WaveB = __webpack_require__(34);
	
	var _WaveB2 = _interopRequireDefault(_WaveB);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var query = exports.query = '** extracted graphql fragment **';
	
	var WTH = function WTH(_ref) {
	  var _ref$data = _ref.data,
	      kclbanner = _ref$data.kclbanner,
	      kcllogo = _ref$data.kcllogo,
	      kclone = _ref$data.kclone,
	      kcltwo = _ref$data.kcltwo,
	      kclthree = _ref$data.kclthree,
	      kclphone = _ref$data.kclphone,
	      kclmac = _ref$data.kclmac,
	      wall = _ref$data.wall,
	      rcsa = _ref$data.rcsa,
	      rcsb = _ref$data.rcsb,
	      rcsc = _ref$data.rcsc;
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement('article', { style: { backgroundImage: 'url("' + kclbanner.sizes.src + '"), url("' + kclbanner.sizes.tracedSVG + '")', backgroundPosition: 'center', backgroundSize: 'cover', minHeight: '50vh' } }),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container centerAlign', style: { paddingTop: '0' } },
	        _react2.default.createElement(_gatsbyImage2.default, { className: 'caseLogo', sizes: kcllogo.kcllogochild.sizes, alt: 'KCL Astute Capital Limited' }),
	        _react2.default.createElement(
	          'h1',
	          { className: 'smallerHone' },
	          'KCL Astute Capital Limited'
	        ),
	        _react2.default.createElement('img', { src: _Fill2.default, alt: 'Nisadhya - Divider', style: { margin: '0.75rem 0' } }),
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: '0' } },
	          'Building awareness using Facebook and driving sales.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { style: { backgroundImage: 'url("' + wall.sizes.src + '"), url("' + wall.sizes.tracedSVG + '")', backgroundPosition: 'center', backgroundSize: 'contain' } },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container full-Width centerAlign', style: { color: '#fff', alignItems: 'flex-start', justifyContent: 'space-between' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30 mobBottommargin' },
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: '3rem' } },
	              '8.8%'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              'lift in daily camera captures'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30 mobBottommargin' },
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: '3rem' } },
	              '92%'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              'on-target reach on Facebook'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30' },
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: '3rem' } },
	              '87%'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              'on-target reach on Instagram'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { style: { backgroundColor: '#f8f8f8' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'container centerAlign' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: kclmac.kclmacchild.sizes, alt: 'Spa Prana', style: { width: '100%', marginBottom: '1.5rem' } }),
	        _react2.default.createElement(
	          'h2',
	          { className: 'smallerHone' },
	          'Their Story.'
	        ),
	        _react2.default.createElement('img', { src: _Fill2.default, alt: 'Nisadhya - Divider', style: { margin: '0.75rem 0' } }),
	        _react2.default.createElement(
	          'p',
	          { style: { fontSize: '1.38316rem' } },
	          _react2.default.createElement(
	            'span',
	            { className: 'gradient' },
	            'Meet KCL Astute Capital Limited.'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: '0' } },
	          'KCL Astute Capital Limited is a Merchant Banker licensed by Securities Board of Nepal (SEBON) to render Portfolio Management Services. KCL Astute has the mission to deliver risk-adjusted performance in the field of investment management and management consulting. The company\u2019s vision is to be a one-window solution to all investment and financial needs. '
	        )
	      ),
	      _react2.default.createElement('img', { src: _Wave2.default, alt: 'Divider', style: { width: '100%', display: 'block' } })
	    ),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container full-Width' },
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-50 mobBottommargin' },
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: kclone.kclonechild.sizes, alt: 'Spa Prana', style: { width: '100%' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-50 paddingLeft' },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'block' } },
	            _react2.default.createElement(
	              'h1',
	              { className: 'smallerHone' },
	              'Their Goal.'
	            ),
	            _react2.default.createElement('img', { src: _Fill2.default, alt: 'Nisadhya - Divider', style: { margin: '0.75rem 0' } }),
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: '1.38316rem' } },
	              _react2.default.createElement(
	                'span',
	                { className: 'gradient' },
	                'Building awareness and driving sales.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              'KCL wanted to increase their brand awareness to reach a wide audience throughout the Kathmandu Valley using the Facebook platform and then drive potential customers to their facility.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { style: { backgroundColor: '#f8f8f8' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'container full-Width reverseRow' },
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-50 mobBottommargin' },
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: kclone.kclonechild.sizes, alt: 'Spa Prana', style: { width: '100%' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-50 paddingRight' },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'block' } },
	            _react2.default.createElement(
	              'h1',
	              { className: 'smallerHone' },
	              'Our Solution.'
	            ),
	            _react2.default.createElement('img', { src: _Fill2.default, alt: 'Nisadhya - Divider', style: { margin: '0.75rem 0' } }),
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: '1.38316rem' } },
	              _react2.default.createElement(
	                'span',
	                { className: 'gradient' },
	                'Regular social media updates and ads.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Before working with KCL Astute Capital Limited, they had a very inactive Facebook page and found that their content was not relevant to their audience.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'In order to increase awareness about them on Facebook, our plan was to first identify a specific target group that could relate to the contents that KCL would put out. Our second step was to slowly to bring back their Facebook page up and running by regularly updating with relevant and engaging contents. '
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              'Once the page was built up, we started doing social media ads in the form of photos and videos to the said target group. Our solution proved success as KCL saw a high drive on their page engagement and sales.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('img', { src: _Wave2.default, alt: 'Divider', style: { width: '100%', display: 'block' } })
	    ),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container full-Width', style: { justifyContent: 'space-between' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-49 mobBottommargin' },
	          _react2.default.createElement(_gatsbyImage2.default, { className: 'caseImg', sizes: kcltwo.kcltwochild.sizes, alt: 'Spa Prana', style: { width: '100%' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-49' },
	          _react2.default.createElement(_gatsbyImage2.default, { className: 'caseImg', sizes: kclthree.kclthreechild.sizes, alt: 'Spa Prana', style: { width: '100%' } })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { style: { backgroundColor: '#f8f8f8' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'centerAlign', style: { display: 'block' } },
	            _react2.default.createElement(
	              'h1',
	              { className: 'smallerHone' },
	              'Products Used'
	            ),
	            _react2.default.createElement('img', { src: _Divider2.default, alt: 'Nisadhya - Divider', style: { margin: '0.75rem 0' } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'full-Width', style: { alignItems: 'flex-start', justifyContent: 'space-between' } },
	          _react2.default.createElement('div', { className: 'half-Width-30 mobBottommargin' }),
	          _react2.default.createElement('div', { className: 'half-Width-30 mobBottommargin' }),
	          _react2.default.createElement('div', { className: 'half-Width-30' })
	        )
	      ),
	      _react2.default.createElement('img', { src: _Wave2.default, alt: 'Divider', style: { width: '100%', display: 'block' } })
	    ),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'centerAlign', style: { display: 'block' } },
	            _react2.default.createElement(
	              'h1',
	              { className: 'smallerHone' },
	              'Related Case Study'
	            ),
	            _react2.default.createElement('img', { src: _Divider2.default, alt: 'Nisadhya - Divider', style: { margin: '0.75rem 0' } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'full-Width', style: { alignItems: 'flex-start', justifyContent: 'space-between' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30 mobBottommargin' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case-studies' },
	              _react2.default.createElement(
	                'div',
	                { style: { overflow: 'hidden' } },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/case-studies/kcl-astute/' },
	                  _react2.default.createElement(_gatsbyImage2.default, { className: 'case-studies-img', sizes: rcsa.rcsachild.sizes, alt: '' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { padding: '1.0875rem' } },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'smallerHone' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'gradient' },
	                    'KCL Astute.'
	                  )
	                ),
	                _react2.default.createElement('img', { src: _Fill2.default, style: { margin: '.75rem 0' }, alt: 'Nisadhya - Divider' }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'KCL Astute Capital Limited is a Merchant Banker licensed by Securities Board of Nepal (SEBON) to render Portfolio Management Services.'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/case-studies/kcl-astute/', className: 'slide gradient' },
	                  'View Case Study'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case-studies' },
	              _react2.default.createElement(
	                'div',
	                { style: { overflow: 'hidden' } },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/case-studies/wanderthirst-hostels/' },
	                  _react2.default.createElement(_gatsbyImage2.default, { className: 'case-studies-img', sizes: rcsb.rcsbchild.sizes, alt: '' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { padding: '1.0875rem' } },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'smallerHone' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'gradient' },
	                    'Wanderthirst Hostels.'
	                  )
	                ),
	                _react2.default.createElement('img', { src: _Fill2.default, style: { margin: '.75rem 0' }, alt: 'Nisadhya - Divider' }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Prabhu Pay App allows its users to simplify the payment process. With this App, the consumers can easily make payments for the goods purchased and services rendered.'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/case-studies/wanderthirst-hostels/', className: 'slide gradient' },
	                  'View Case Study'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'half-Width-30' })
	        )
	      )
	    )
	  );
	};
	
	exports.default = WTH;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-case-studies-kcl-astute-js-4b1ecf1deefe98dfd92c.js